export const iconFontAwesomeSpinnersFan = (
	<i className="fa-solid fa-fan"></i>
);
